export default __webpack_public_path__ + "static/media/20.29bc40eb.png";